export default "__VITE_ASSET__RHRXEaoN__"